import { c as _c } from "react/compiler-runtime";
import React from "react";
import { BadgeExternalLink } from "@components/common/badge-external-link";

/**
 * A React functional component that renders a collection of external link badges.
 *
 * @param {Object} props - The property object passed to the component.
 * @param {Object[]} props.items - An array of items containing label and href for each badge.
 * @param {string} props.items[].label - The text label displayed on the badge.
 * @param {string} props.items[].href - The URL linked to the badge.
 */
export const FixtureLibsUsed = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="my-2 flex flex-wrap items-center gap-3">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(item) {
  return <BadgeExternalLink key={item.label} href={item.href}>{item.label}</BadgeExternalLink>;
}